export default {
  disableMainLayout: "disableMainLayout",
  sidebarIsHovering: "sidebarIsHovering",
  setLoadingOn: "setLoadingOn",
  setLoadingOff: "setLoadingOff",
  resetLoading: "resetLoading",
  setColors: "setColors",
};
